export const alertModule = {
    namespaced: true,
    state: {
        value: false,
        type: null,
        message: null,
    },
    mutations: {
        view(state, alert){
            state.value = true;
            state.type = alert.type;
            state.message = alert.message;
        },
        close(state){
            state.value = false;
            state.type = null;
            state.message = null;
        },
    },

    actions: {}
}
